import {Menu} from '@headlessui/react';
import React from 'react';

import {VisibilityBadge} from 'src/components/h5/ModelLabels';
import {H5ForecastListing, listingKey} from 'src/lib/api/h5';
import * as tw from 'src/lib/tailwindClasses';

export default function AddModelMenu({
  listings,
  nameOf,
  showModelIds = false,
  onAdd,
  className,
  wrapperClassName = '',
  children,
}: {
  // The models not yet on the chart.
  listings: H5ForecastListing[];
  nameOf: (listing: H5ForecastListing) => string;
  showModelIds?: boolean;
  onAdd: (listing: H5ForecastListing) => void;
  className?: string;
  wrapperClassName?: string;
  // The button that opens the list.
  children: React.ReactNode;
}) {
  return (
    <Menu as="div" className={`relative ${wrapperClassName}`}>
      <Menu.Button className={className}>{children}</Menu.Button>
      <Menu.Items className={`${tw.floatingDropdown} left-0 z-20 px-3 whitespace-nowrap`}>
        {listings.map((listing) => (
          <Menu.Item key={listingKey(listing)}>
            {({active}) => (
              <button
                type="button"
                className={`flex items-center gap-2 py-1 text-left ${active ? 'text-blue-700' : ''}`}
                onClick={() => onAdd(listing)}
              >
                <span>{nameOf(listing)}</span>
                <VisibilityBadge visibility={listing.visibility} />
                {/* Plain text, since a menu's arrow keys reach only its items. */}
                {showModelIds && (
                  <span className="text-xs text-gray-400">{`${listing.modelType} / ${listing.modelId}`}</span>
                )}
              </button>
            )}
          </Menu.Item>
        ))}
      </Menu.Items>
    </Menu>
  );
}
